import React, { Component } from 'react'
import { Button } from '@/components/ui/button'
import { Settings as Stngs } from 'react-feather'
import _kebabCase from 'lodash/kebabCase'

import Preferences from '../utils/Preferences'
import Snippets from '../utils/Snippets'
import BreadcrumbCard from '../utils/BreadcrumbCard'
import Theme from '../utils/Theme'

import '../App.css'

class Settings extends Component {
    static getTitle() {
        return "Settings"
    }
    static getSearchTitle() {
        return Settings.getTitle()
    }
    static getLink() {
        return '/' + _kebabCase(Settings.getSearchTitle())
    }
    static getTags() {
        return []
    }
    static getNavIcon(className) {
        return <Stngs className={ className } />
    }

    constructor(props) {
        super(props)

        const defs = Preferences.getDefaults()
        this.state = {
            setFocus: Preferences.getGlobalValue("focus", null, defs.focus),
            numSnippets: Snippets.getList().length,
            themeSelection: Theme.getSaved(),
        }

        this.onFocusChanged = this.onFocusChanged.bind(this)
        this.onThemeChanged = this.onThemeChanged.bind(this)
        this.onResetAllPreferences = this.onResetAllPreferences.bind(this)
        this.onResetAllSnippets = this.onResetAllSnippets.bind(this)
    }

    onFocusChanged(event) {
        const focus = event.target.checked
        Preferences.setGlobalValue("focus", null, focus)
        this.setState(Object.assign({}, this.state, {
            setFocus: focus,
        }))
    }
    onThemeChanged(event) {
        const value = event.target.value
        Theme.set(value)
        this.setState(Object.assign({}, this.state, {
            themeSelection: value,
        }))
    }
    onResetAllPreferences() {
        Preferences.resetAll()

        const defs = Preferences.getDefaults()
        Theme.set('system')
        this.setState(Object.assign({}, this.state, {
            setFocus: defs.focus,
            themeSelection: 'system',
        }))
    }
    onResetAllSnippets() {
        Snippets.resetAll()
        this.setState(Object.assign({}, this.state, {
            numSnippets: Snippets.getList().length,
        }))
    }

    render() {
        const breadcrumbs = [
            {
                title: Settings.getTitle(),
                active: true,
            }
        ]

        return (
            <BreadcrumbCard breadcrumbs={ breadcrumbs }>
                <div className="form-padding space-y-4">
                    {/* Theme */}
                    <div>
                        <label className="block text-sm font-semibold mb-2">Theme</label>
                        <div className="space-y-1">
                            { ['light', 'dark', 'system'].map(value => (
                                <label key={ value } className="flex items-center gap-2 text-sm cursor-pointer">
                                    <input
                                        id={ `theme-${value}` }
                                        type="radio"
                                        name="theme"
                                        value={ value }
                                        checked={ this.state.themeSelection === value }
                                        onChange={ this.onThemeChanged }
                                        className="accent-primary"
                                    />
                                    { value === 'system' ? 'Follow system / browser setting' : value.charAt(0).toUpperCase() + value.slice(1) }
                                </label>
                            )) }
                        </div>
                    </div>

                    {/* Behavior */}
                    <div>
                        <label className="block text-sm font-semibold mb-2">Behavior</label>
                        <label className="flex items-center gap-2 text-sm cursor-pointer">
                            <input
                                type="checkbox"
                                checked={ this.state.setFocus }
                                onChange={ this.onFocusChanged }
                                className="accent-primary"
                            />
                            Focus the first text entry if available
                        </label>
                    </div>

                    {/* Reset preferences */}
                    <div>
                        <Button variant="outline" className="text-amber-600 border-amber-500 hover:bg-amber-50 dark:hover:bg-amber-900/20" onClick={ this.onResetAllPreferences }>
                            Reset All Preferences
                        </Button>
                        <p className="text-sm text-muted-foreground mt-1">
                            This will include all the word wrap preferences in each tool.
                        </p>
                    </div>

                    {/* Remove snippets */}
                    <div>
                        <Button variant="outline" className="text-amber-600 border-amber-500 hover:bg-amber-50 dark:hover:bg-amber-900/20" onClick={ this.onResetAllSnippets }>
                            Remove All Snippets
                        </Button>
                        <p className="text-sm text-muted-foreground mt-1">
                            This will include all the { this.state.numSnippets } snippets.
                        </p>
                    </div>
                </div>
            </BreadcrumbCard>
        )
    }
}

export default Settings
